import { render, staticRenderFns } from "./articleRecord.vue?vue&type=template&id=41daa709&scoped=true&"
import script from "./articleRecord.vue?vue&type=script&lang=js&"
export * from "./articleRecord.vue?vue&type=script&lang=js&"
import style0 from "./articleRecord.vue?vue&type=style&index=0&id=41daa709&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41daa709",
  null
  
)

export default component.exports